import { render, staticRenderFns } from "./CheckoutBuy.vue?vue&type=template&id=68f586e8"
import script from "./CheckoutBuy.vue?vue&type=script&lang=js"
export * from "./CheckoutBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports